const LOCAL_URLS = {
    ADMIN_CENTER: "http://admin:2000",
    CRM: "http://localhost:5173",
    DUE_DILIGENCE: "http://manage:2000/next",
    MAINTENANCE: "http://manage:2000/next",
    REMOTE_MAINTENANCE: "https://happy.co/products/services/happy-force",
    RESIDENT_PORTAL: ""
};
const DEV_URLS = {
    ADMIN_CENTER: "https://admin.dev.happyco.com",
    CRM: "https://crm.dev.happyco.com",
    DUE_DILIGENCE: "https://manage.dev.happyco.com/next",
    MAINTENANCE: "https://manage.dev.happyco.com/next",
    REMOTE_MAINTENANCE: "https://happy.co/products/services/happy-force",
    RESIDENT_PORTAL: "https://resident.dev.happyco.com/companies"
};
const STAGING_URLS = {
    ADMIN_CENTER: "https://admin.staging.happyco.com",
    CRM: "https://crm.staging.happyco.com",
    DUE_DILIGENCE: "https://manage.staging.happyco.com/next",
    MAINTENANCE: "https://manage.staging.happyco.com/next",
    REMOTE_MAINTENANCE: "https://happy.co/products/services/happy-force",
    RESIDENT_PORTAL: "https://resident.staging.happyco.com/companies"
};
const PROD_URLS = {
    ADMIN_CENTER: "https://admin.happyco.com",
    CAPEX: "https://am.happyhq.co/asset_management",
    CRM: "https://crm.happyco.com",
    DUE_DILIGENCE: "https://manage.happyco.com/next",
    MAINTENANCE: "https://manage.happyco.com/next",
    REMOTE_MAINTENANCE: "https://happy.co/products/services/happy-force",
    RESIDENT_PORTAL: "https://resident.happyco.com/companies"
};
const URL_SUFFIXES = {
    ADMIN_CENTER: "/b/:businessId/settings",
    CAPEX: "/:businessId/properties",
    CRM: "/b/:businessId",
    DUE_DILIGENCE: "/b/:businessId",
    MAINTENANCE: "/b/:businessId"
};
const URLS = {
    LOCAL: LOCAL_URLS,
    DEV: DEV_URLS,
    STAGING: STAGING_URLS,
    PROD: PROD_URLS
};
/**
 * @param product A graphql ProductName, or ADMIN_CENTER
 * @param businessId Used to link to the corresponding product environment in the destination product
 * @param env The deploy environment to link to
 * @returns A url to the destination product
 */ const getProductUrl = (product, businessId, env = "PROD")=>{
    const root = URLS[env][product];
    if (root === undefined) {
        // Unknown product, use a placeholder route
        return "/";
    }
    const suffix = URL_SUFFIXES[product];
    if (businessId !== undefined && suffix !== undefined) {
        return root + URL_SUFFIXES[product].replace(":businessId", businessId);
    }
    return root;
};
const getProductLineUrl = (productLine)=>{
    switch(productLine){
        case "HAPPY_ASSET":
            return "https://happy.co/products/suites/happy-asset";
        case "HAPPY_FORCE":
            return "https://happy.co/products/services/happy-force";
        case "HAPPY_PROPERTY":
            return "https://happy.co/products/suites/happy-property";
    }
};

export { getProductLineUrl, getProductUrl };
